import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'

export const getDashboardReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/dashboard', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data,
    needToCancelRequest: true,
    endPoint: '/report/dashboard'
  })
}
